// extracted by mini-css-extract-plugin
export default {"AddButton":"EducationExpenses_AddButton__BhpEB"};